import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Tabs, TabList, Tab, TabPanels, TabPanel, List, UnorderedList, ListItem } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from 'mobx-react';
import admin from '../../../api/admin';
import { IAsset } from '../../../models/asset';
import { GetAssetResponse } from '../../../models/admin-api/dto';
import ProgressLoader from '../../progressLoader';


const SharedProjectAssetViewer = props => {

    const [isLoading, setIsLoading] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState<IAsset>();

    let { id, spId, p } = useParams();


    useEffect(() => {

        const assetid = Number(id);
        const sharedProjectId = Number(spId)
        const pin = p || null;

        if (assetid) {

            if (assetid !== undefined) {
                setIsLoading(true);

                admin.Assets.GetAssetViewer(assetid, sharedProjectId, pin).then(
                    (res: GetAssetResponse) => {
                        if (res?.result!) {
                            setSelectedAsset(res.result);
                            setIsLoading(false);
                        }
                        else {

                            setIsLoading(false)
                        }
                    },
                    (error) => {
                        alert('Error Retrieving asset!' + error);
                        setIsLoading(false);
                    }
                );
            }
            else {
                alert("Missing Asset ID!")
            }
        }
    }
        , [props.assetId, id]);


    return (
        <>
            {isLoading ? (<ProgressLoader />) :

                (<>

                    {id ? (

                        <Tabs padding={5} isFitted variant='enclosed'>
                            <TabList mb='1em'>
                                <Tab>Asset Details</Tab>

                                <Tab>Attachments</Tab>
                            </TabList>
                            <TabPanels>
                                <TabPanel>
                                    <UnorderedList>
                                        <ListItem>{selectedAsset?.name!}</ListItem>
                                        <ListItem>{selectedAsset?.type!}</ListItem>
                                        <ListItem>{selectedAsset?.manufacturer!}</ListItem>
                                        <ListItem>{selectedAsset?.model!}</ListItem>
                                        <ListItem>{selectedAsset?.serialNo!}</ListItem>
                                    </UnorderedList>
                                </TabPanel>
                                <TabPanel>
                                    {/* 
                                    <AssetAttachmentList assetId={props.assetId} /> */}

                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    ) : (<b>No Asset Information Found!</b>)}

                </>)
            }

        </>
    )
}


SharedProjectAssetViewer.propTypes = {
    assetId: PropTypes.number,

}



export default SharedProjectAssetViewer